interface Props {
  storeUrl?: string;
  title?: string;
  message?: string;
  updateLabel?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export default function UpdateRequiredScreen({
  storeUrl,
  title = 'Update required',
  message = 'Please update Tupai to continue.',
  updateLabel = 'Update now',
  onRetry,
  retryLabel,
}: Props) {
  return (
    <main className="fixed inset-0 z-[9999] overflow-y-auto bg-surface safe-area safe-area-top safe-area-x">
      <div className="flex min-h-full flex-col items-center justify-center gap-4 px-8 py-8 text-center">
        <h1 className="font-display text-xl text-content">{title}</h1>
        <p className="max-w-sm text-base text-muted" role="status">
          {message}
        </p>
        {onRetry && retryLabel && (
          <button type="button" className="cta-primary" onClick={onRetry}>
            {retryLabel}
          </button>
        )}
        {storeUrl && (
          <a className="cta-primary" href={storeUrl} target="_blank" rel="noopener noreferrer">
            {updateLabel}
          </a>
        )}
      </div>
    </main>
  );
}
